import React from "react";
import { LoadingScreen } from "@packsize/components";
import { Navigate, useSearchParams } from "react-router-dom";

import { useAuthentication, useToken, useUser } from "../../../hooks";

interface AuthenticationRouteProps {
	readonly children: React.ReactNode;
}

export const AuthenticationRoute: React.FC<AuthenticationRouteProps> = ({ children }) => {
	const [searchParams] = useSearchParams();

	const { decodedToken } = useToken();
	const { currentUser } = useUser();

	const { authenticated, getLoginDestination } = useAuthentication();

	if (authenticated === undefined || currentUser === undefined) {
		return <LoadingScreen />;
	}

	if (authenticated === true) {
		const returnTo = searchParams.get("returnTo");
		return <Navigate to={getLoginDestination(currentUser, decodedToken, returnTo)} replace />;
	}

	return children;
};
